import React from "react";

const Carousel = (props) => {
    return (
        <div id="instaCarousel" className="carousel carousel-dark slide" data-bs-ride="carousel">
            <div className="carousel-indicators">
                {props.images && props.images.map((img, i) => (
                    <button key={i} type="button" data-bs-target="#instaCarousel" data-bs-slide-to={i} className={(i===0) ? "active" : ""} aria-current={i===0} aria-label={`Slide ${i}`}></button>
                ))}
            </div>
            <div className="carousel-inner">
                {props.images && props.images.map((imageLink, i) => (
                    <div key={i} className={`carousel-item ${(i===0) && "active"}`}>
                        <img src={imageLink} className="d-block w-100" alt="..." />
                    </div>
                ))}
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#instaCarousel" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#instaCarousel" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>      
    );
}

export default Carousel;

